import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=521d01f2&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports